import React from 'react';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { cn } from '@/lib/utils';

interface ShellPopoverProps {
  readonly trigger: React.ReactNode;
  readonly children: React.ReactNode;
  readonly className?: string;
  readonly ariaLabel: string;
}

/**
 * The popovers hanging off the sidebar footer, in v11 tokens.
 *
 * Radix already closes on Escape and on a click outside, and returns focus to
 * the trigger; this only dresses it.
 */
export const ShellPopover: React.FC<ShellPopoverProps> = ({
  trigger,
  children,
  className,
  ariaLabel,
}) => (
  <Popover>
    <PopoverTrigger asChild>{trigger}</PopoverTrigger>
    <PopoverContent
      side="top"
      align="start"
      aria-label={ariaLabel}
      className={cn(
        'w-72 rounded-2xl border-v11-border bg-v11-surface p-0 text-v11-text-primary shadow-xl',
        className
      )}
    >
      {children}
    </PopoverContent>
  </Popover>
);
